<template>
  <div class="home-middle">
    <title-one :title="'达州市高新区地图'" />
    <div class="rank-one left">
      <map-bg :show-axis="true">
        <template slot="label">
          <agency-label
            :size="item.size || 1"
            :agency-name="item.name"
            :active="true"
            class="agency-label"
            :style="{top: `${item.y}px`, left: `${item.x}px`,'z-index': 22}"
          />
        </template>
      </map-bg>
    </div>

    <div class="save-btn wh-flex-center">
      <el-button class="next-btn" type="" icon="el-icon-right" circle title="前往园区数据管理" @click="$router.push('/park')" />
      <el-button class="up-btn" plain icon="el-icon-download" @click="saveFn">
        保存并下载当前数据
      </el-button>
      <div class="up-warp">
        <wh-uploader
          ref="upFile"
          :not-pic="true"
          :is-private="true"
          :valid-ext="['json']"
          :preset-file-list="upFile || []"
          :limit="1"
          :before-upload-request-handle="beforeUploadFn"
          @listChanged="upFile=$event.fileListResult"
        >
          <div slot="trigger" class="upload-file">
            <el-button plain icon="el-icon-upload2">
              点击上传资料
            </el-button>
          </div>
        </wh-uploader>
        <span class="btn-tips">(上传文件名必须是agency_data.json文件，否则无效)</span>
      </div>
    </div>
  </div>
</template>

<script>
import TitleOne from '@/components/TitleOne/TitleOne'
import AgencyLabel from '../../../components/AgencyLabel/AgencyLabel'
import MapBg from '@/views/Home/components/MapBg'
import { mapState } from 'vuex'
import { deepCopy } from '@/utils/tool'
import WhUploader from '@/components/WhUploader/WhUploader'
export default {
  name: 'AgencyMiddle',
  components: { WhUploader, MapBg, AgencyLabel, TitleOne },
  props: {
    initItem: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      mapInnerPos: {
        x: 0,
        y: 0
      },
      mapBg: require('../../Home/images/map-bg.png'),
      selectIndex: 0,
      agencyTimer: null,
      spaceTime: 1000 * 10,
      item: {},
      upFile: []
    }
  },
  computed: {
    ...mapState({
      'initCurAgency': 'curAgency',
      'upToken': 'upToken'
    })
  },
  watch: {
    initCurAgency: {
      handler(newV, oldV) {
        this.item = deepCopy(newV)
      }
    },
    immediate: true,
    deep: true
  },
  methods: {
    getMousePos(event) {
      this.mapInnerPos.x = event.offsetX || event.layerX
      this.mapInnerPos.y = event.offsetY || event.layerY
    },
    selectIndexFn(item, index) {
      this.selectIndex = index
      this.$store.commit('changeCurAgency', item)
    },
    saveFn() {
      this.$confirm('点击确定保存保存并下载后, 新数据将会被下载', '温馨提示', {
        confirmButtonText: '保存并下载',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit('download')
      }).catch(() => {})
    },
    beforeUploadFn(file) {
      return new Promise((resolve, reject) => {
        const Bearer = `Bearer ` + `${this.upToken.access_token}`
        this.$Api.fileToken({
          file_name: file.file.name.replace('%', '').replace(',', ''),
          bucket_name: 'dazhou',
          ...{}
        }, false, {
          headers: {
            Authorization: Bearer
          }
        }).then(res => {
          const fd = new FormData()
          fd.append('file', file.file)
          fd.append('token', res.token)
          fd.append('key', res.key)
          resolve(fd)
        }).catch(err => {
          this.$message.warning('获取token失败:' + err)
          reject(err)
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .rank-one{
    width: 100%;
    height: 864px;
    background: url("../../Home/images/middle-1.png") top left no-repeat;
    background-size: 100% 100%;
    padding: 10px 4px 4px 4px;
    .agency-label{
      position: absolute;
      top: 0;
      left: 0;
      transform: translate(-50%, -50%);
    }
  }
  .rank-two{
    width: 100%;
    height: 294px;
    background: url("../../Home/images/middle-2.png") top left no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: flex-start;
    position: relative;
    .m-left{
      padding: 20px 10px 20px 20px;
    }
    .center-one{
      left: 121px;
    }
    .center-two{
      left: 399px;
    }
    .center-three{
      left: 677px;
    }
    .center-one, .center-two, .center-three{
      position: absolute;
      top: 67px;
    }
    .ring-name{
      font-size: 24px;
      position: absolute;
      top: 230px;
    }
    .ring-one{
      left: 175px;
    }
    .ring-two{
      left: 438px;
    }
    .ring-three{
      left: 734px;
    }
  }
  .save-btn{
    padding: 20px;
    text-align: center;
    margin-top: 60px;
    .up-btn{
      margin-left: 20px;
      margin-right: 20px;
    }
    /deep/ .el-button{
      width: 200px;
    }
  }
  .up-warp{
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    .btn-tips{
      margin-left: 4px;
      color: #fff;
      font-size: 12px;
    }
  }
  .m-top{
    margin-top: 16px;
  }
  .left{
    position: relative;
    top: -6px;
  }
  .next-btn{
    width: 40px!important;
  }
</style>
